import { useGetIntegrationSettingsQuery } from '@xemplo/business-unit-query';
import { Modal, useModalDialog } from '@xemplo/modal-dialog';

import { EditSettingsContent } from './edit-settings-modal/edit-settings-modal';
import { SettingsCard } from './settings-card/settings-card';
import { BusinessUnitSettingsProps } from './business-unit-settings.types';

export function BusinessUnitSettings(props: Readonly<BusinessUnitSettingsProps>) {
  const { businessUnitId, viewOnly, className } = props;
  const modalDialog = useModalDialog({ id: 'edit-business-unit-settings-modal' });
  const { data, isLoading } = useGetIntegrationSettingsQuery({ businessUnitId });
  const settings = data?.settings;

  return (
    <>
      <SettingsCard
        businessUnitId={businessUnitId}
        viewOnly={viewOnly}
        onEdit={modalDialog.openModalDialog}
        className={className}
      />
      <Modal.Dialog {...modalDialog.dialogProps}>
        {modalDialog.isOpen && !isLoading && !!settings && (
          <EditSettingsContent
            businessUnitId={businessUnitId}
            settings={settings}
            originalRows={data?.rows ?? []}
            onClose={modalDialog.closeDialog}
          />
        )}
      </Modal.Dialog>
    </>
  );
}

export default BusinessUnitSettings;
